<template>
  <div class="dropdown field-wrapper__dropdown">
    <div ref="r_dropdowm_cont" :class="main_class+' c_ui5_inp_cont'">
      <label class="input__label">
        <input ref="r_dropdowm_inp" type="text" onclick="stop_bubble(event);" class="c_qs_inp input__input-field c_ui5_inp" :class="[input_class, {'disabled': disabled}]" :value="get_label()" :disabled="disabled">
        <span class="svg-icon svg-icon_size-8px">
          <svg width="8" height="5" viewbox="0 0 8 5"><polyline class="svg-icon__polyline" points="0.5,0 4,4 7.5,0" fill="none" stroke-width="1"/></svg>
        </span>
        <span class="input__label-span">{{ placeholder }}</span>
      </label>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'dropdown_qsearch',
    props: {
      value: {}, //{ label:'', value:'' }
      disabled: {type: Boolean, default: false},
      placeholder: {type: String, default: ''},

      main_class: {type: String, default: 'input input_dropdown input_size-50 input_animate-label'},
      input_class: {type: String, default: ''},

      is_add_new: {type: Boolean, default: false},
      prefix: {type: String, default: ''},//обязательно при is_add_new=true
      url_html: {type: String, default: ''},
      url_html_init: {type: String, default: ''},

      /**
       * An optional callback function that is called each time the selected
       * value(s) change. When integrating with Vuex, use this callback to trigger
       * an action, rather than using :value.sync to retreive the selected value.
       * @type {Function}
       * @param {Object || String} val
       */
      onChange: {
        type: Function,
        default: function (val, key_code) {
          this.$emit('input', val, key_code)
        }
      },
    },

    created(){
      setTimeout( () =>{
        window.global.init_ir_select_type_autoselect( this.$refs.r_dropdowm_inp,
          {  options: {
              html: this.url_html,
              html_init: this.url_html_init,
              max_height: 300,
              min_length: 1,
              is_readonly: false,
              add_html:''
            },
            cl_select: null,
            cl_select_confirm: (sel_uri, sel_title, this_obj)=>{
              let val={
                label: sel_title,
                value: sel_uri
              };

              if ( sel_title==null ){
                val={
                  label: '',
                  value: ''
                };
              }

              this.$emit('input', val);
              if ( sel_title!=null ){
                this.onChange ? this.onChange(val) : null;
              }
            },
            cl_key: (sel_id, cur_title, this_obj, j_select_div, key_code)=>{
              let val={
                label: $(this_obj).val(),//так чтобы было с пробелами
                value: ''
              };

              if ( cur_title==null ){
                val={
                  label: '',
                  value: ''
                };
              }
              else if ( this.is_add_new && this.prefix.length>0 && cur_title.length>0 ){
                let real_val=$( this.$refs.r_dropdowm_inp ).val();
                if ( real_val==null ) real_val='';
                val={
                  label: real_val,
                  value: this.prefix+'://~'+cur_title
                };

              }

              this.$emit('input', val);
              if ( this.is_add_new && this.prefix.length>0 && cur_title.length>0 ){
                this.onChange ? this.onChange(val, key_code) : null;
              }
            },
            cl_blur: (sel_uri, sel_title, this_obj)=>{
              if (sel_uri==null && sel_title==null && $(this_obj).val().length==0){
                let val={
                  label: '',
                  value: ''
                };
                this.$emit('input', val);
                this.onChange ? this.onChange(val) : null;
              }
            },
            cl_key_enter: null,
            cl_load_next: null,
            cl_while_scrolling: null
          }
        );
      }, 50);
    },

    methods: {
      get_label() {
        let val_str='';
        if (typeof this.value === 'object') val_str=this.value.label;

        if ( val_str.length>0 ){
          $( this.$refs.r_dropdowm_cont ).addClass('focus');
        }
        else if ( !$( this.$refs.r_dropdowm_inp ).is(':focus') ) {
          $( this.$refs.r_dropdowm_cont ).removeClass('focus');
        }

        return val_str;
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/lib/dropdown_qsearch.vue